import React, { useState } from "react";
import tickIcon from "../../../../icons/tickIcon.png";
import "./ChameleonVote.css";

const ChameleonVote = ({
  users,
  localPlayer,
  updateVoteData,
  currentVotingData,
}) => {
  const [votedPlayer, selectVote] = useState(null);

  const selectPlayer = (playerClicked) => {
    if (!currentVotingData[localPlayer.name]) {
      if (playerClicked === votedPlayer) {
        selectVote(null);
      } else selectVote(playerClicked);
    }
  };

  return (
    <div className="playerVotingList">
      <div className="voteTitleContainer">
        {votedPlayer === null ? (
          <p className="voteTitleText "> Discuss & vote for the Chameleon</p>
        ) : (
          <div style={{ width: "100%" }}>
            {!currentVotingData[localPlayer.name] ? (
              <p className="voteTitleText ">
                Confirm vote for: {votedPlayer}
                <img
                  className="tickIcon"
                  src={tickIcon}
                  alt="confirm the category selection"
                  style={{ height: "30px", width: "30px" }}
                  onClick={() => {
                    updateVoteData(votedPlayer, localPlayer.name);
                  }}
                />
              </p>
            ) : (
              <p className="voteTitleText ">You voted for: {votedPlayer} </p>
            )}
          </div>
        )}
      </div>

      <div className="voteTableContainer">
        <div className="playerVotingContainer">
          <div className="playerVoteTitle">Player</div>
          <div className="playerVoteTitle">Voted?</div>
        </div>

        {users.map((user) => (
          <div key={user.name} className="playerVotingContainer">
            <div className="playerName">
              {user.name !== localPlayer.name ? (
                <div className="checkboxContainer">
                  <input
                    type="checkbox"
                    checked={user.name === votedPlayer ? true : false}
                    readOnly
                  ></input>
                  <span
                    className="checkmark"
                    onClick={() => selectPlayer(user.name)}
                  ></span>
                </div>
              ) : (
                <div className="checkboxContainer">
                  <span className="fauxCheckmark"></span>
                </div>
              )}
              <p
                className="playerNameText"
                style={
                  user.name === localPlayer.name
                    ? { color: "yellow" }
                    : { color: "" }
                }
              >
                {user.name}
              </p>
            </div>
            {currentVotingData[user.name] !== undefined ? (
              <div className="playerVoteNum">Yes</div>
            ) : (
              <div className="playerVoteNum">No</div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ChameleonVote;
